if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.COPOW_URL = "https://copow-delivery-app-cac23e803740.herokuapp.com";
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', async (e)=>{
						e.preventDefault();
						await this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(async e=>{
						e.preventDefault();
						e.target.blur();
						await this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		async updateCartQty(item, newQty){

			let alert = null;
			const isInventoryLimitApplied = item?.dataset?.invLimit === "true";

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			console.log("==>>",item.id.split("-").pop());
			let res = await fetch(`${this.COPOW_URL}/api/ext/check/inventory?shop=s98k1i-gs.myshopify.com&variantId=${item.id.split("-").pop()}`, {
				method: 'GET'
			});
			let response = await res.json();

			// console.log("===>>>",response, newQty);
			this.inventoryDetail = response;
			let updatedQuantity = parseInt(newQty, 10) || 0;

			let cartResponse = await fetch("/cart.js");
			let cart = await cartResponse.json();
			let cartItem = cart.items.find((itm) => itm.id == item.id.split("-").pop());

			if (response.totalQuantityAvailable <= 0 && (response.inventoryPolicy != "CONTINUE" || isInventoryLimitApplied)) {
				alert = document.createElement('span');
				alert.classList.add('alert', 'alert--error');
				alert.textContent = "Out of stock - No items available.";
				this.form.prepend(alert);
				updatedQuantity = 0;
			}
			else if(updatedQuantity > response.totalQuantityAvailable && (response.inventoryPolicy != "CONTINUE" || isInventoryLimitApplied)) {
				// Calculate total requested quantity (newQty + existing in cart)
				const currentCartQuantity = cartItem ? cartItem.quantity : 0;
				const totalRequestedQuantity = updatedQuantity - response.totalQuantityAvailable;
				console.log(response.totalQuantityAvailable, updatedQuantity, cartItem.quantity);
				
				if (totalRequestedQuantity > 0) {
					// Insufficient inventory
					updatedQuantity = updatedQuantity - totalRequestedQuantity;
					alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					const _msg = updatedQuantity > 0 ? `Only ${updatedQuantity} ${updatedQuantity > 1 ? "items were" : "item was"} added to your cart due to availability.` : `Only ${updatedQuantity} items were added to your cart due to availability.`
					alert.textContent = _msg;
				}
			}

			  
			  let qtyInput = item.querySelector('.qty');
			  console.log(updatedQuantity, qtyInput, newQty);
			//   if (qtyInput) {
			// 	qtyInput.value = updatedQuantity;
			//   }

			  let latestQuantity = cartItem.quantity >= 0 ? cartItem.quantity + updatedQuantity : updatedQuantity;
			  console.log(latestQuantity);
			  
			//   if (updatedQuantity === 0) {
			// 	if (!alert) {
			// 	  alert = document.createElement('span');
			// 	  alert.classList.add('alert', 'alert--error');
			// 	  alert.textContent = "Insufficient inventory levels - No items are available.";
			// 	}
			// 	this.form.prepend(alert);
			// 	this.form.classList.remove('processing');
			// 	// item.querySelector('.qty').value = parseInt(item.querySelector('.qty').value) - 1;
			// 	return;
			//   }

			// if(!(response.totalQuantityAvailable > 0)){
			// 	console.log("ISSUES==>>");
			// 	let alert = document.createElement('span');
			// 	alert.classList.add('alert', 'alert--error');
			// 	alert.textContent = "Insufficient inventory levels";
			// 	this.form.prepend(alert);
			// 	this.form.classList.remove('processing');
			// 	console.log(item.querySelector(".qty"));
				
			// 	item.querySelector('.qty').value = parseInt(item.querySelector('.qty').value) - 1;
			// 	return;
			// }

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: updatedQuantity
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
					const event = new Event('cart-updated');
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(async ()=>{
				let theCart =  document.getElementById('AjaxCartForm')
				await theCart.updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}

(function() {
	const cartMessageBlock = document.querySelector('.cart__message-widget');
	let settings = JSON.parse(
		localStorage.getItem("copow-settings") || "{}"
	);
	if(!cartMessageBlock) return;

	let msg = null;
	if (settings["Delivery Method"] == "Delivery") {
		msg = cartMessageBlock.dataset?.msgDelivery || '';
	} else if (settings["Delivery Method"] == "Pick Up") {
		msg = cartMessageBlock.dataset?.msgPickup || '';
	} else {
		msg = cartMessageBlock.dataset?.msgShipping || '';
	}

	if(msg && msg.length) {
		cartMessageBlock.innerHTML = `<p>${msg}</p>`;
		cartMessageBlock.classList.remove('hidden');
	} else {
		cartMessageBlock.classList.add('hidden');
	}
})();